import React from 'react';
import {
  Stack,
  Header,
  Text,
  SegmentedSelectionLite,
  Badge,
} from '@piwikpro/ui-components';
import { TFunction } from 'react-i18next';

type Period = 'year' | 'month'

export const PlanCard: React.FunctionComponent<{
  header: string
  priceHeader: React.ReactNode
  subheader: string
  children: React.ReactNode
  totalSave?: string
  onPeriodChange?: (period: Period) => void
  period?: Period
  t: TFunction
}> = ({
  header,
  priceHeader,
  subheader,
  children,
  totalSave,
  onPeriodChange,
  period,
  t,
}) => {
  const yearlyName = (
    <Stack spacing="extraNarrow" verticalAlignment="center">
      <Stack.Item>
        {t('marketing.change-plan-overlay.period-selector.yearly')}
      </Stack.Item>
      <Stack.Item>
        <div style={{ marginTop: '-2px' }}>
          <Badge
            display="block"
            size="small"
            text={
              totalSave
                ? t('marketing.change-plan-overlay.period-selector.save', { value: totalSave })
                : '%'
            }
            color="light-green"
          />
        </div>
      </Stack.Item>
    </Stack>
  );

  return (
    <Stack vertical spacing="narrow">
      <Stack.Item fill>
        <Stack verticalAlignment="center">
          <Stack.Item fill>
            <Header type="medium">
              <div style={{ whiteSpace: 'break-spaces' }}>
                {header}
              </div>
            </Header>
          </Stack.Item>
          <Stack.Item>
            {
              onPeriodChange && (
                <Stack spacing="none">
                  <Stack.Item previousSpacing="wide">
                    <SegmentedSelectionLite
                      items={[
                        { value: 'year', name: yearlyName },
                        { value: 'month', name: t('marketing.change-plan-overlay.period-selector.monthly') },
                      ]}
                      onChange={(v) => { onPeriodChange(v as Period); }}
                      value={period || 'year'}
                    />
                  </Stack.Item>
                </Stack>
              )
            }
          </Stack.Item>
        </Stack>
      </Stack.Item>
      <Stack.Item>
        {priceHeader}
      </Stack.Item>
      <Stack.Item>
        <Text type="subdued">
          {subheader}
        </Text>
      </Stack.Item>
      <Stack.Item fill previousSpacing="default">
        {children}
      </Stack.Item>
    </Stack>
  );
};
